/* eslint-disable */

import owlCarousel from 'owl.carousel';
import '../util/jquery.owl-filter.js';

export default {
  init() {
	  // let slider = $('.customers__slider');
    //
		// slider.owlCarousel({
	  //   items: 1,
		// 	center: true,
    //   stagePadding: 75,
    //   responsive: {
    //     767: {
    //       items: 2
    //     },
    //     1025: { items: 3 },
    //     1500: { items: 4 },
    //     1800: { items: 5 }
    //   }
	  // });
		// $('.js-slider-prev').on('click', e => {
		// 	e.preventDefault();
		// 	slider.trigger('prev.owl.carousel')
		// });
		// $('.js-slider-next').on('click', e => {
		// 	e.preventDefault();
		// 	slider.trigger('next.owl.carousel')
		// });
		// $('.js-slider-filter').on('change', e => {
		// 	e.preventDefault();
		// 	let category = $(e.target).val();
		// 	slider.owlFilter(category ? '.' + $(e.target).val() : '*');
		// });
    // slider.on('initialized.owl.carousel', function(event) {
    //   $('.js-slider-prev').addClass('disabled')
    // })
    // slider.on('changed.owl.carousel', function(event) {
    //   var currentItem = event.item.index;
    //   $('.js-slider-prev').toggleClass('disabled', event.item.index == 0);
    //   $('.js-slider-next').toggleClass('disabled', event.item.index == event.item.count - 1);
    // })
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}



// WEBPACK FOOTER //
// ./scripts/routes/references.js